/**
 * Browser detection helper.
 *
 * Extrai o nome do browser a partir do userAgent do navegador.
 * Usado no login (enviar device identity ao backend) e no useOneSignal (compat).
 */
export function detectBrowser(): string {
  const ua = navigator.userAgent;
  if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  if (ua.includes('Edg')) return 'Edge';
  return 'Unknown';
}
